import { useState } from 'react';
import { SegmentTrackName } from '~/Constants/Segment.constants';
import { Segment } from '~/Helpers/Segment.helper';

export const usePrivateLayoutTitle = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [bookingsMenuEl, setBookingsMenuEl] = useState(null);

  const handleMountMenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleOpenManageBookingsMenu = (event: any) => {
    setBookingsMenuEl(event.currentTarget);
    Segment.track(SegmentTrackName.MANUAL_BOOKING_CLICKED);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setBookingsMenuEl(null);
  };

  return {
    anchorEl,
    bookingsMenuEl,
    handleOpenManageBookingsMenu,
    handleMountMenu,
    handleCloseMenu,
  };
};
